import { HomeSectionType } from "../../models/homeSections";

export const HOME_SECTION_TYPE_LABELS: Record<HomeSectionType, string> = {
  banners_carousel: "Carrusel de Banners",
  featured_events: "Eventos Destacados",
  events_listing: "Listado de Eventos",
};

export const HOME_SECTION_EVENTS_LISTING_TYPE: HomeSectionType = "events_listing";
export const HOME_SECTION_BANNERS_TYPE: HomeSectionType = "banners_carousel";
export const HOME_SECTION_FEATURED_TYPE: HomeSectionType = "featured_events";

export const HOME_SECTIONS_CONFIG_DEBOUNCE_MS = 500;
